import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProformaModalService } from 'src/app/services/proforma-modal/proforma-modal.service';
import { Proforma } from 'src/app/pages/sales/proforma/proforma.model';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { OrderService } from 'src/app/services/order/order.service';
import { GeneralService } from 'src/app/services/general/general.service';

@Component({
  selector: 'app-proforma-two',
  templateUrl: './proforma-two.component.html',
  styleUrls: ['./proforma-two.component.scss']
})
export class ProformaTwoComponent extends DestructorComponent implements OnInit, OnDestroy {

  selectedProforma: Proforma | null = null;
  isGeneratingPDF: boolean = false;
  validityOfLC: string = '';
  isLoading = false;
  constructor(
    private proformaModalService: ProformaModalService,
    private _orderService: OrderService,
    private _generalService: GeneralService
  ) {
    super();
  }

  ngOnInit(): void {
    // Subscribe to selected proforma changes
    this.subscriptions.push(
      this.proformaModalService.selectedProforma$.subscribe(proforma => {
        if (proforma) {
          this.selectedProforma = proforma;
          // Reset validity field when new proforma is loaded
          this.validityOfLC = '';
          console.log('Proforma received in proforma-two modal:', proforma);
        }
      })
    );
  }

  // Helper method to format date
  formatDate(dateString: string | undefined): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  }

  // Helper method to get vehicle price
  getVehiclePrice(): string {
    if (this.selectedProforma && this.selectedProforma.items && this.selectedProforma.items.length > 0) {
      return this.selectedProforma.items[0].amount.toLocaleString();
    }
    return '5,000';
  }

  // Helper method to get total amount
  getTotalAmount(): string {
    if (this.selectedProforma && this.selectedProforma.items && this.selectedProforma.items.length > 0) {
      const total = this.selectedProforma.items.reduce((sum, item) => sum + item.amount, 0);
      return total.toLocaleString();
    }
    return '5,000';
  }

  // Helper method to get vehicle image
  getVehicleImage(vehicle: any): string {
    if (vehicle && vehicle.pictures && vehicle.pictures.length > 0) {
      return vehicle.pictures[0];
    }
    return 'assets/media/stock/600x400/img-1.jpg'; // Fallback image
  }

  // Helper method to get individual vehicle price
  getIndividualVehiclePrice(index: number): string {
    if (this.selectedProforma && this.selectedProforma.items && this.selectedProforma.items[index]) {
      return this.selectedProforma.items[index].amount.toLocaleString();
    }
    return '5,000';
  }

  // TrackBy function for vehicle loop
  trackByVehicleId(index: number, vehicle: any): string {
    return vehicle._id || vehicle.chassis_no || index.toString();
  }

  // Helper method to get vehicle count
  getVehicleCount(): number {
    if (this.selectedProforma && this.selectedProforma.vehicles) {
      return this.selectedProforma.vehicles.length;
    }
    return 0; // Return 0 when no vehicles to trigger fallback display
  }

  // Helper method to get vehicle count for display (shows 1 when no data for totals)
  getDisplayVehicleCount(): number {
    const count = this.getVehicleCount();
    return count > 0 ? count : 1; // Show 1 in totals even when no real data
  }

  // Method to save proforma data and log the validity of L/C
  saveProformaData(): void {

    this.isLoading = true;
    this.subscriptions.push(
      this._orderService.UpdateValue(this.selectedProforma?._id || "", { validity_of_lc: this.validityOfLC }).subscribe({
        next: (response) => {
          console.log('Proforma updated successfully:', response);
          this.isLoading = false;

        },
        error: (error) => {
          console.error('Error updating proforma:', error);
          this.isLoading = false;

        }
      })
    )

  }

  // Method to handle print functionality using generalService generatePDF
  printProforma(): void {
    if (!this.selectedProforma || !this.selectedProforma._id) {
      console.error('No proforma selected');
      return;
    }

    // Show loading overlay
    this.isGeneratingPDF = true;

    // Prepare data for API call
    const data = {
      order_id: this.selectedProforma._id,
      type: 'proforma-two'
    };

    console.log('Generating PDF for proforma:', data);

    // Call the generatePDF service
    this.subscriptions.push(
      this._generalService.generatePDF(data).subscribe({
        next: (res: any) => {
          console.log('PDF generation response:', res);
          if (res && res.data && res.data.url) {
            // Download the PDF
            this.downloadPDF(res.data.url);

            // PDF generated successfully
            this.isGeneratingPDF = false;
            console.log('PDF generated and downloaded successfully');
          } else {
            console.error('Invalid response format:', res);
            this.isGeneratingPDF = false;
            alert('PDF generation failed. No URL received.');
          }
        },
        error: (error: any) => {
          console.error('Error generating PDF:', error);
          this.isGeneratingPDF = false;
          alert('Error generating PDF. Please try again.');
        }
      })
    );
  }

  // Helper method to download PDF
  private downloadPDF(url: string): void {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';

    // Create filename with proforma number
    const filename = `Proforma_Invoice_${this.selectedProforma?.order_number || 'P-19138'}_${new Date().toISOString().split('T')[0]}.pdf`;
    link.download = filename;

    // Trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    console.log(`Downloaded PDF: ${filename}`);
  }
}
